import _ from 'lodash';
import moment from 'moment';

export default function (state, action) {
    if (!state) {
        state = {
            loaded: false,
            listed: [],
            indexed: {},
            lastUpdate: 0,
        };
    }

    switch (action.type) {
        case 'EVENT_NEWS_LOADED':
            state = Object.assign({}, state, {
                fetchTime: moment(action.fetchTime),
                loaded: true,
                listed: [...action.news],
                indexed: _(action.news).reduce((result, item, key) => {
                    result[item.id] = item;
                    return result;
                }, {}),
                lastUpdate: action.timestamp,
            });
            break;
    }

    return state;
}
